import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import VisitorParkingForm from "./views/VisitorParkingForm";
import MemberLoginForm from "./views/MemberLoginForm";
import TicketsPage from "./views/TicketsPage";
import ProfilePage from "./views/ProfilePage";
import ForgotPassword from "./views/ForgotPassword";
import ResetPassword from "./views/ResetPassword";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // <-- start as null (unknown)

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token); // true if token exists, false if not
  }, []);

  // Protect private routes
  const PrivateRoute = ({ children }) => {
    if (isAuthenticated === null) return null; // or show a spinner/loading
    return isAuthenticated ? children : <Navigate to="/member-login" />;
  };

  // Prevent access to login if already logged in
  const PublicOnlyRoute = ({ children }) => {
    if (isAuthenticated === null) return null; // or show a spinner/loading
    return isAuthenticated ? <Navigate to="/tickets" /> : children;
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<VisitorParkingForm />} />

        <Route
          path="/member-login"
          element={
            <PublicOnlyRoute>
              <MemberLoginForm setIsAuthenticated={setIsAuthenticated} />
            </PublicOnlyRoute>
          }
        />

        <Route
          path="/forgot-password"
          element={
            <PublicOnlyRoute>
              <ForgotPassword />
            </PublicOnlyRoute>
          }
        />

        <Route
          path="/reset-password"
          element={
            <PublicOnlyRoute>
              <ResetPassword />
            </PublicOnlyRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />

        <Route
          path="/tickets"
          element={
            <PrivateRoute>
              <TicketsPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
